import { ResponseData, Err } from 'types';

import { http } from '.';

export const createJobNumber = async (payload) => {
  return await http.post<Err, ResponseData<1>>(`/InvoiceJobs/Create`, payload);
};

export const updateJobNumber = async (payload) => {
  return await http.put<Err, ResponseData<1>>(`/InvoiceJobs/Update`, payload);
};

export const getMyInvoiceJobs = async (
  pageSize: number,
  pageIndex: number,
  searchText?: string
) => {
  const params = new URLSearchParams({
    pageSize: String(pageSize),
    pageIndex: String(pageIndex),
  });
  if (searchText) {
    params.append('searchText', searchText);
  }
  return await http.get<Err, ResponseData<any>>(
    `/InvoiceJobs/GetMyInvoiceJobs?${params.toString()}`
  );
};
export const getReportJobs = async () => {
  return await http.get<Err, ResponseData<any>>(`/Report/GetReportJobs`);
};

export const getJobs = async (invoiceId) => {
  return await http.get<Err, ResponseData<any>>(`/InvoiceJobs/GetJobs`, {
    params: {
      invoiceId,
    },
  });
};

export const deleteJob = async (jobId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`InvoiceJobs/${jobId}`);
};
